export default __webpack_public_path__ + "static/media/mathis-jolicoeur.251c7016.jpg";